var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"secondary"}},'v-icon',attrs,false),on),[_vm._v(" mdi-web ")])]}}])},[_c('span',[_vm._v("Issue du téléservice")])])
}
var staticRenderFns = []

export { render, staticRenderFns }